module.exports = __webpack_public_path__ + "img/qq.17c12c36.svg";